import React, { Component } from 'react';
import './Header.css';
import { Dropdown } from 'element-react';

import logo from '../../assets/logo.png';
import adminAvatarJordi from '../../assets/jordi.jpeg';
import adminAvatarAlex from '../../assets/alex.jpeg';

import firebase from 'firebase';
import { connect } from 'react-redux';

//@connect(mapStateToProps)
class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: props.user
    };
    this.signOut = this.signOut.bind(this);
  }

  signOut(command) {
    if (command === 'b') firebase.auth().signOut();
  }

  render() {
    return (
      <div className="wrapper">
        <div className="corporate">
          <img src={logo} alt="Logo" />
          <p>Cabanyes entre Valls SL</p>
        </div>
        <div className="user-admin">
          <Dropdown
            onCommand={this.signOut}
            menu={
              <Dropdown.Menu>
                <Dropdown.Item command="a">Usuari: {this.state.user}</Dropdown.Item>
                <Dropdown.Item command="c">Configurar dades d'administrador</Dropdown.Item>
                <Dropdown.Item divided command="b">
                  Cerrar sessión
                </Dropdown.Item>
              </Dropdown.Menu>
            }
          >
            <span className="el-dropdown-link">
              {this.state.user === 'jlopez90@gmail.com' ? (
                <img src={adminAvatarJordi} alt="Logo" />
              ) : (
                <img src={adminAvatarAlex} alt="Logo" />
              )}
              <i className="el-icon-caret-bottom el-icon--right" />
            </span>
          </Dropdown>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({ user: state.user });

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js